// import './assets/main.scss'
import * as Sentry from '@sentry/vue'
import { v4 as uuidv4 } from 'uuid'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import firebase from 'firebase/compat/app'
import vVisible from './directives/v-visible'
import vTooltip from './directives/v-tooltip'

import App from './App.vue'
import router from './router'

const isTesting = !!window.Cypress
const isLive = location.host === 'screener.mable.co.uk'

/* === FIREBASE SETUP === */
const firebaseDev = {
    databaseURL: 'https://mable-dev-eu.europe-west1.firebasedatabase.app',
    apiKey: 'AIzaSyAttYI7T4g1sBLwR7xB7RKWst6r-4SifE4',
    authDomain: 'mable-dev.firebaseapp.com'
  },
  firebaseProd = {
    databaseURL: 'https://mable-live-eu.europe-west1.firebasedatabase.app',
    apiKey: 'AIzaSyDEnJht32sJ5VeDnu1u28_5QjWgP3VL360',
    authDomain: 'radiant-fire-15.firebaseapp.com'
  },
  firebaseTesting = {
    databaseURL: 'https://mable-testing.firebaseio.com',
    apiKey: 'AIzaSyDTlBRhbClkps0XSI-i57DE3VvOZ1upH5Q',
    authDomain: 'mable-testing.firebaseapp.com'
  }

let sentryEnvironment

if (isLive) {
  console.log('Running in production mode:', _ENVIRONMENT_)
  firebase.initializeApp(firebaseProd)
  sentryEnvironment = 'production'
} else if (isTesting) {
  console.log('Running in testing mode:', _ENVIRONMENT_)
  firebase.initializeApp(firebaseTesting)
  sentryEnvironment = 'testing'
} else {
  console.log('Running in development mode:', _ENVIRONMENT_)
  firebase.initializeApp(firebaseDev)
  sentryEnvironment = 'development'
}

/* === DEVICE TRACKING HELPERS === */
function getOrCreateDeviceUUID(): string {
  const DEVICE_UUID_KEY = 'mable_device_uuid'
  let deviceUUID: string | null = null

  try {
    deviceUUID = localStorage.getItem(DEVICE_UUID_KEY)
    if (!deviceUUID) {
      deviceUUID = uuidv4()
      localStorage.setItem(DEVICE_UUID_KEY, deviceUUID)
    }
  } catch (error) {
    console.warn('localStorage unavailable, generating temporary UUID:', error)
    deviceUUID = uuidv4()
  }

  return deviceUUID
}

function getStoredSchool(): string | null {
  try {
    return localStorage.getItem('mable_device_school')
  } catch (error) {
    console.warn('localStorage unavailable, cannot retrieve school:', error)
    return null
  }
}

const app = createApp(App)

/* === SENTRY SETUP === */
Sentry.init({
  app,
  dsn: _SENTRY_DSN_,
  environment: sentryEnvironment,
  integrations: [Sentry.browserTracingIntegration()],
  // Performance Monitoring
  tracesSampleRate: 0.2, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/]
})

// Immediately load device tracking data from localStorage and set as global tags
const deviceUUID = getOrCreateDeviceUUID()
const storedSchool = getStoredSchool()

Sentry.getGlobalScope().setTag('deviceUUID', deviceUUID)
if (storedSchool) {
  Sentry.getGlobalScope().setTag('schoolName', storedSchool)
}

app.use(createPinia())
app.use(router)
app.directive('visible', vVisible)
app.directive('tooltip', vTooltip)

app.mount('#app')
